export default __webpack_public_path__ + "static/media/wangye_web.2f6c2cf7.png";